import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import { markUnreadRoute, messagesKey, threadsEnterpriseKey, threadsKey } from '@features/messaging';
import axiosInstance from '@server/axiosInstance';
import { notificationsKey } from '@features/notifications';

type UseUnreadMessagesProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useUnreadMessages = ({ setErrorText }: UseUnreadMessagesProps) => {
  const client = useQueryClient();

  const { mutate: unreadMessages } = useMutation({
    mutationFn: (variables: { thread_id: number, is_enterprise?: number, company_id?: number }) =>
      axiosInstance.post(markUnreadRoute, variables).then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries(threadsEnterpriseKey);
        client.invalidateQueries(threadsKey);
        client.invalidateQueries(notificationsKey);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    unreadMessages,
  };
};
